var styles = {
  "themeLight": "_themeLight_1wmjs6z_60",
  "themeDark": "_themeDark_1wmjs6z_63",
  "dropdown": "_dropdown_1wmjs6z_67",
  "triggerWrapper": "_triggerWrapper_1wmjs6z_74",
  "contentWrapper": "_contentWrapper_1wmjs6z_78",
  "fadeInBottomToTop": "_fadeInBottomToTop_1wmjs6z_1",
  "fadeInTopToBottom": "_fadeInTopToBottom_1wmjs6z_1",
  "fadeInLeftToRight": "_fadeInLeftToRight_1wmjs6z_1",
  "fadeInRightToLeft": "_fadeInRightToLeft_1wmjs6z_1",
  "wrapperHidden": "_wrapperHidden_1wmjs6z_109",
  "modeClassic": "_modeClassic_1wmjs6z_129",
  "modeRock": "_modeRock_1wmjs6z_133"
};
export { styles as default };
